import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Styles from "../../assets/css/Pages/PrivacyPolicy.module.css";
import { Helmet } from "react-helmet-async";
// Loaders
import Loading from "../Loadings/Loading";
// Global Imports
import { useGlobalState } from "../../Functions/GlobalStates";

const PrivacyPolicy = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Referrences
  const CheckPageStateRef = useRef(false); // Ref for the check Page

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  const PagesImages = require.context(
    "../../assets/images/Pages/PrivacyPolicy/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const PageImages = [
    PagesImages("./1.avif"),
    PagesImages("./2.avif"),
    PagesImages("./3.avif"),
    PagesImages("./4.avif"),
    PagesImages("./5.avif"),
    PagesImages("./6.avif"),
    PagesImages("./7.avif"),
    PagesImages("./8.avif"),
  ];

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([PageImages[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  });
  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Privacy Policy – Affiliators 🔒</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Read the Affiliators Privacy Policy to understand how we collect, use, and protect your personal data while using our services."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="privacy policy, data protection, user information, affiliates privacy, data use"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Privacy Policy – Affiliators 🔒" />
        <meta
          property="og:description"
          content="Understand how Affiliators handles and safeguards your data."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/privacypolicy"
        />

        {/* Image Meta Tags for Social Sharing */}
        {/*
  <meta
    property="og:image"
    content="/images/policy/privacypolicy.png"
  />
  <meta
    name="twitter:image"
    content="/images/policy/privacypolicy.png"
  />
  */}

        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy – Affiliators 🔒" />
        <meta
          name="twitter:description"
          content="Learn how we protect your data and privacy at Affiliators."
        />

        {/* Indexing and Canonical URL */}
        <meta name="robots" content="index, follow" />
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/privacypolicy"
        /> */}

        {/* Author and Language */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta httpEquiv="Content-Language" content="en" />
      </Helmet>


      <div className={Styles.PrivacyPolicyContainer}>
        <section className={Styles.PrivacyPolicySection1}>
          <h1>Privacy Policy</h1>
          <div className={Styles.PrivacyPolicySection1ImgPara1Container}>
            <img src={PageImages[0]} alt="Welcome To My Website" />
            <p>
              Your privacy is important to us. This Privacy Policy outlines how we
              handle information on [Your Blog Name].
            </p>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara1Container}>
            <h2>Information We Collect</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara2Container}>
              <img src={PageImages[1]} alt="Welcome To My Website" />
              <p>
                We do not collect any personally identifiable information from our
                users. However, we may track likes, views, and engagement metrics
                to analyze content performance and improve user experience.
              </p>
            </div>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara2Container}>
            <h2>How We Use Engagement Data</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara3Container}>
              <img src={PageImages[2]} alt="Welcome To My Website" />
              <p>
                We use aggregated likes and views data to display content ratings
                and website rankings. This helps users make informed decisions
                based on community preferences.
              </p>
            </div>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara3Container}>
            <h2>Affiliate Links</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara4Container}>
              <img src={PageImages[3]} alt="Welcome To My Website" />
              <p>
                Some pages may contain affiliate links. Clicking on these links
                may lead to third-party websites where purchases may result in a
                commission for us at no extra cost to you.
              </p>
            </div>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara4Container}>
            <h2>Cookies & Tracking</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara5Container}>
              <img src={PageImages[4]} alt="Welcome To My Website" />
              <p>
                We do not store or track personal data through cookies. However,
                third-party services we use (such as analytics or affiliate
                networks) may utilize cookies to enhance functionality.
              </p>
            </div>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara5Container}>
            <h2>Third-Party Links</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara6Container}>
              <img src={PageImages[5]} alt="Welcome To My Website" />
              <p>
                Our website may contain links to external sites. We are not
                responsible for the privacy practices or content of these
                third-party websites.
              </p>
            </div>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara6Container}>
            <h2>Data Security</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara7Container}>
              <img src={PageImages[6]} alt="Welcome To My Website" />
              <p>
                We prioritize security and do not collect or store any private
                user data. Any information displayed is purely for informational
                purposes.
              </p>
            </div>
          </div>
          <div className={Styles.PrivacyPolicySection1HeadingImgPara7Container}>
            <h2>Thank You ✨</h2>
            <div className={Styles.PrivacyPolicySection1ImgPara8Container}>
              <img src={PageImages[7]} alt="Welcome To My Website" />
              <p>
                We may update this Privacy Policy from time to time. Any changes
                will be reflected on this page.
              </p>
            </div>
          </div>

          <h2>Customer Support</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us
            at <NavLink to="/customer-support">Contact us</NavLink>
          </p>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default PrivacyPolicy;
